import { jsx as _jsx } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-components/hooks/useStyles';
import { OptionStateType } from '@kubit/web-ui-components/option/types';
import { getOptionState } from '@kubit/web-ui-components/option/utils';
import React from 'react';
import { STYLES_NAME } from '../../../../constants/stylesName/stylesName';
import { SelectorRowOptionStandAlone } from './selectorRowOptionStandAlone';
export const SelectorRowOption = ({ variant, ...props }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.SELECTOR_ROW,
        variantName: variant,
    });
    const hasFocusStyles = !!styles?.[OptionStateType.FOCUS];
    const [hover, setHover] = React.useState(false);
    const [focused, setFocused] = React.useState(false);
    const filling = false;
    const _onFocus = (event) => {
        props.onFocus?.(event);
        setFocused(hasFocusStyles);
    };
    const _onBlur = (event) => {
        props.onBlur?.(event);
        setFocused(false);
    };
    const state = getOptionState(props.disabled, focused, props.selected, props.multiSelect, hover, filling);
    return (_jsx(SelectorRowOptionStandAlone, { ...props, state: state, styles: styles, onBlur: _onBlur, onFocus: _onFocus, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) }));
};
//# sourceMappingURL=selectorRowOption.js.map